import React from 'react';
import { Button } from './ui/Button';
import { Mail, Phone, Clock } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-24 bg-[#111113]" data-id="element-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-14">
          {/* Contact Form */}
          <div className="glass-card p-8 rounded-2xl" data-id="element-15">
            <h2 className="text-3xl font-semibold text-white mb-6" data-id="element-16">
              Projekt anfragen
            </h2>
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-17">
              <div data-id="element-18">
                <label htmlFor="name" className="block text-sm font-medium text-zinc-400 mb-2" data-id="element-19">
                  Name
                </label>
                <input type="text" id="name" className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white placeholder-zinc-600 focus:border-blue-500/50 focus:ring-1 focus:ring-blue-500/50 outline-none transition-colors" placeholder="Ihr Name" data-id="element-20" />
              </div>

              <div data-id="element-21">
                <label htmlFor="email" className="block text-sm font-medium text-zinc-400 mb-2" data-id="element-22">
                  Email
                </label>
                <input type="email" id="email" className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white placeholder-zinc-600 focus:border-blue-500/50 focus:ring-1 focus:ring-blue-500/50 outline-none transition-colors" placeholder="ihre@email.de" data-id="element-23" />
              </div>

              <div data-id="element-24">
                <label htmlFor="message" className="block text-sm font-medium text-zinc-400 mb-2" data-id="element-25">
                  Projektbeschreibung
                </label>
                <textarea id="message" rows={4} className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white placeholder-zinc-600 focus:border-blue-500/50 focus:ring-1 focus:ring-blue-500/50 outline-none transition-colors resize-none" placeholder="Erzählen Sie uns kurz von Ihrem Vorhaben..." data-id="element-26"></textarea>
              </div>

              <div className="p-4 bg-white/5 rounded-lg border border-dashed border-white/10 text-center" data-id="element-27">
                <p className="text-sm font-light text-zinc-500" data-id="element-28">
                  Dateien können im nächsten Schritt sicher hochgeladen werden.
                </p>
              </div>

              <Button fullWidth size="lg" data-id="element-29">
                Anfrage senden
              </Button>
            </form>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col justify-center space-y-8" data-id="element-30">
            <div data-id="element-31">
              <h3 className="text-2xl font-semibold text-white mb-4" data-id="element-32">
                Kontaktieren Sie uns
              </h3>
              <p className="font-light text-zinc-400 text-lg leading-relaxed" data-id="element-33">
                Wir helfen Ihnen gerne dabei, Ihre Immobilienprojekte optimal zu
                präsentieren. Schreiben Sie uns oder rufen Sie an.
              </p>
            </div>

            <div className="space-y-6" data-id="element-34">
              <div className="flex items-start gap-4" data-id="element-35">
                <div className="w-10 h-10 rounded-full bg-blue-500/10 border border-blue-500/20 flex items-center justify-center flex-shrink-0" data-id="element-36">
                  <Mail className="w-5 h-5 text-blue-400" data-id="element-37" />
                </div>
                <div data-id="element-38">
                  <p className="font-medium text-white" data-id="element-39">Email</p>
                  <a href="mailto:hallo@archaitechs.de" className="font-light text-zinc-400 hover:text-blue-400 transition-colors" data-id="element-40">
                    hallo@archaitechs.de
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-41">
                <div className="w-10 h-10 rounded-full bg-blue-500/10 border border-blue-500/20 flex items-center justify-center flex-shrink-0" data-id="element-42">
                  <Phone className="w-5 h-5 text-blue-400" data-id="element-43" />
                </div>
                <div data-id="element-44">
                  <p className="font-medium text-white" data-id="element-45">Telefon</p>
                  <p className="font-light text-zinc-400" data-id="element-46">
                    +49 (0) 30 123 456 78
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-47">
                <div className="w-10 h-10 rounded-full bg-blue-500/10 border border-blue-500/20 flex items-center justify-center flex-shrink-0" data-id="element-48">
                  <Clock className="w-5 h-5 text-blue-400" data-id="element-49" />
                </div>
                <div data-id="element-50">
                  <p className="font-medium text-white" data-id="element-51">Antwortzeit</p>
                  <p className="font-light text-zinc-400" data-id="element-52">
                    Wir antworten in der Regel innerhalb von 2 Stunden.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}